import { useEffect } from 'react';

export default function SplashScreen({ onReady }) {
  useEffect(() => {
    // Se lo splash nativo ha già finito, procedi subito
    if (window.__splashDone && window.__splashDone()) {
      onReady();
      return;
    }
    // Altrimenti aspetta max 2 secondi e procedi comunque
    const timeout = setTimeout(() => onReady(), 2000);
    return () => clearTimeout(timeout);
  }, [onReady]);

  return null;
}
